import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const handleFindServices = () => {
    if (window.location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.location.href = '/';
    }
  };

  return (
    <footer className="w-full bg-gray-900 text-white py-12 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">

          {/* Logo & Description */}
          <div>
            <div className="mb-4">
              <img src="/logos/logo-white.png" alt="HIVE" className="h-14 w-auto" />
            </div>
            <p className="text-gray-400 text-sm">
              Connecting communities with trusted local services across Sri Lanka.
            </p>
          </div>

          {/* For Customers */}
          <div>
            <h4 className="font-bold mb-4 text-white">For Customers</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>
                <button onClick={handleFindServices} className="hover:text-yellow-400 transition-colors text-left">
                  Find Services
                </button>
              </li>
              <li><Link to="/how-it-works" className="hover:text-yellow-400 transition-colors">How It Works</Link></li>
              <li><Link to="/safety" className="hover:text-yellow-400 transition-colors">Safety</Link></li>
            </ul>
          </div>

          {/* For Providers */}
          <div>
            <h4 className="font-bold mb-4 text-white">For Providers</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><Link to="/become-a-provider" className="hover:text-yellow-400 transition-colors">Become a Provider</Link></li>
              <li><Link to="/resources" className="hover:text-yellow-400 transition-colors">Resources</Link></li>
              <li><Link to="/pricing" className="hover:text-yellow-400 transition-colors">Pricing</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-bold mb-4 text-white">Company</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><Link to="/about" className="hover:text-yellow-400 transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-yellow-400 transition-colors">Contact</Link></li>
              <li><Link to="/terms" className="hover:text-yellow-400 transition-colors">Terms</Link></li>
              <li><Link to="/privacy" className="hover:text-yellow-400 transition-colors">Privacy</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-gray-400 text-sm">
          <p>&copy; 2025 HIVE. All rights reserved. Made in Sri Lanka 🇱🇰</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;